module.exports = __webpack_public_path__ + "img/ac3.63008766.png";